import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'atlassian-navigation.notifications.tooltip',
		defaultMessage: 'Notifications',
		description: 'Tooltip for notification drawer icon in global-navigation',
	},
	oldLabel: {
		id: 'atlassian-navigation.notifications.old-label',
		defaultMessage: 'Notifications',
		description: 'Button label for notification drawer icon in global-navigation',
	},
	label: {
		id: 'atlassian-navigation.notifications.label',
		defaultMessage:
			'{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}',
		description: 'Button label for notification drawer icon in global-navigation',
	},
	overNineNotifications: {
		id: 'atlassian-navigation.notifications.over-nine-notifications',
		defaultMessage: 'Over 9 Notifications',
		description: 'Label for the notification count when there are more than 9 notifications',
	},
});
